import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import moment from 'moment';
import localStorage from '../../utils/localStorage';

const roomNoKey = 'roomNo';
const lastNameKey = 'lastName';
const firstNameKey = 'firstName';

class bookingSummaryStore {

    // Main Properties

    @observable menu = null;
    @observable bookingItems = [];
    @observable bookingFilterItems = [];
    @observable bookingPendingOrders = [];
    @observable bookingRemark = '';
    @observable bookingSearchText = '';
    @observable bookingSearchSubCategory = 'All';
    @observable bookingTotalOrder = 0;
    @observable bookingLoading = false;
    @observable roomNo = '';
    @observable lastname = '';

    // Booking Detail Modal

    @observable bookingDetail = null;
    @observable showBookingDetailModal = false;
    @observable bookingDetailLoading = false;

    // Booking Tab

    @observable bookingTabLoading = false;
    @observable bookingTabCategories = [];
    @observable bookingTabSubCategories = [];
    @observable bookingTabCategoryIdActive = '0';
    @observable bookingDate = '';
    @observable bookingDateText = '';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action getMenu() {
        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getBookingFacility(languageCode).then((resp) => {
            this.menu = resp;
        });
    }

    @action initGetBookings() {
        this.bookingLoading = true;
        const that = this;
        that.roomNo = localStorage.Get(roomNoKey);
        that.lastname = localStorage.Get(lastNameKey);
        if (this.bookingDate === '') {
            const now = moment();
            this.bookingDate = now.toDate();
            this.bookingDateText = now.format('D/M/yyyy');
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        const request = {
            'languageCode': languageCode,
            'date': `${moment(this.bookingDate).format('YYYY-MM-DD')} 00:00:00`
        };
        return ApiCaller.BookingSummaries.getAll(request).then((bookingResponses) => {
            if (bookingResponses && bookingResponses.isSuccess) {
                var model = bookingResponses.model;
                that.bookingTabCategories = model.categoryNames;

                if (that.bookingTabCategoryIdActive === '0') {
                    that.bookingTabCategoryIdActive = that.bookingTabCategories[0].id.toString();
                    that.bookingTabSubCategories = that.bookingTabCategories[0].subCategories;
                } else {
                    const bookingTabCategoryIdByIdActive = that.bookingTabCategories.find(fi => fi.id.toString() === that.bookingTabCategoryIdActive);
                    if (!bookingTabCategoryIdByIdActive) {
                        that.bookingTabCategoryIdActive = that.bookingTabCategories[0].id.toString();
                        that.bookingTabSubCategories = that.bookingTabCategories[0].subCategories;
                    } else {
                        that.bookingTabSubCategories = bookingTabCategoryIdByIdActive.subCategories;
                    }
                }

                that.bookingItems = model.items;
                that.bookingFilterItems = that.bookingItems;

                if (that.bookingFilterItems.length > 0) {
                    that.bookingFilterItems.map((bookingItem) => {
                        return bookingItem.orderQuantity = 0;
                    });
                }
            } else {
                that.bookingTabCategories = [];
                that.bookingTabSubCategories = [];
                that.bookingItems = [];
                that.bookingFilterItems = [];
                that.bookingSearchText = '';
                that.bookingSearchSubCategory = 'All';
            }

            this.searchBookingByNameAndSubCategory();
            this.bookingLoading = false;
        });
    }

    // Transactions

    @action addBookingTransaction() {
        this.bookingDetailLoading = true;
        var firstname = localStorage.Get(firstNameKey);
        var lastname = localStorage.Get(lastNameKey);
        var roomNo = localStorage.Get(roomNoKey);
        var bookingItemId = this.bookingDetail.id;
        var remark = this.bookingDetail.remark;
        const bookingDate = `${moment(this.bookingDate).format('YYYY-MM-DD')} 00:00:00`;

        const request = {
            'bookingItemId': bookingItemId,
            'roomNumber': roomNo,
            'bookingDate': bookingDate,
            'bookingBy': lastname,
            'bookingByFullname': `${firstname} ${lastname}`,
            'remark': remark
        };

        return ApiCaller.BookingTransactions.create(request).then(response => {
            if (response && response.isSuccess) {
                this.initGetBookings().then(() => {
                    this.bookingDetailLoading = false;
                    this.setShowBookingDetailModal(false);
                })
            } else {
                this.bookingDetailLoading = false;
                this.setShowBookingDetailModal(false);
            }

            return response;
        });
    }

    @action getOrderRequest() {
        let orders = [];
        let order = {
            'taskId': this.menu.taskId,
            'menuId': this.menu.taskId,
            'scheduleTime': '',
            'menuQuantity': 1,
            'remark': '',
            'amount': 0
        };

        orders.push(order);

        let summaryRemark = `Category: ${this.bookingDetail.bookingCategoryName}.`;

        if (this.bookingDetail.bookingSubCategoryName !== null) {
            summaryRemark = `${summaryRemark} Sub Category: ${this.bookingDetail.bookingSubCategoryName}).`;
        }

        summaryRemark = `${summaryRemark} Booking Date: ${this.bookingDateText}. Booking Time: ${this.bookingDetail.startTime} - ${this.bookingDetail.endTime}.`;

        if (this.bookingDetail.remark !== '' && this.bookingDetail.remark) {
            summaryRemark = `${summaryRemark} Remark: ${this.bookingDetail.remark}.`;
        }

        const request = {
            'tenantId': localStorage.Get('companyId'),
            'roomNumber': localStorage.Get('roomNo'),
            'guestId': localStorage.Get('customerId'),
            'summaryRemark': summaryRemark,
            'data': orders
        };

        return request;
    }

    @action cancelBookingItem(bookingTransactionId) {
        return ApiCaller.BookingTransactions.delete(bookingTransactionId).then(response => {
            if (response && response.isSuccess) {
                this.initGetBookings().then(() => {
                    this.bookingDetailLoading = false;
                })
            }

            return response;
        });
    }

    // GET Properties

    @action getBookingItemById(id) {
        const bookingItem = this.bookingItems.find(it => it.id === id);
        this.bookingDetail = bookingItem;
        this.showBookingDetailModal = true;

        return bookingItem;
    }

    // Set Properties

    @action setBookingRemark(value) {
        this.bookingRemark = value;
    }

    @action setShowBookingDetailModal(value) {
        this.showBookingDetailModal = value;
    }

    @action setBookingPriceDetail() {
        this.bookingSubTotal = 0;

        this.bookingPendingOrders.map((order) => {
            if (order.price === order.specialPrice) {
                this.bookingSubTotal = this.bookingSubTotal + (order.orderQuantity * order.price);
            } else {
                this.bookingSubTotal = this.bookingSubTotal + (order.orderQuantity * order.specialPrice);
            }

            return this.bookingSubTotal;
        });

        this.bookingVat = this.bookingSubTotal * this.bookingVatTax / 100;
        this.bookingServiceFee = this.bookingSubTotal * this.bookingServiceFeeTax / 100;
        this.bookingTotal = this.bookingSubTotal + this.bookingVat + this.bookingServiceFee;
    }

    @action setBookingTimeSelected(value) {
        this.bookingTimeSelected = value;
        this.bookingTimeDeliver = '';
    }

    @action setBookingTimeDeliver(value) {
        this.bookingTimeDeliver = value;
        this.bookingTimeSelected = '';
    }

    @action setBookingTimeDeliverDate(value) {
        this.bookingTimeDeliverDate = value;
    }

    @action searchBookingByNameAndSubCategory() {
        if (this.bookingSearchText === '' && this.bookingSearchSubCategory === 'All') {
            this.bookingFilterItems = this.bookingItems;
            return;
        }

        if (this.bookingSearchSubCategory === 'All') {
            this.bookingFilterItems = this.bookingItems;
        } else {
            this.bookingFilterItems = this.bookingItems.filter(item => {
                if (item.bookingSubCategoryName) {
                    let subCategoryName = item.bookingSubCategoryName.toLowerCase();
                    return subCategoryName.indexOf(this.bookingSearchSubCategory.toLowerCase()) !== -1;
                }
            });
        }

        if (this.bookingSearchText !== '') {
            this.bookingFilterItems = this.bookingFilterItems.filter(item => {
                let startTime = item.startTime.toLowerCase();
                return startTime.indexOf(this.bookingSearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setBookingSearchText(value) {
        this.bookingSearchText = value;
    }

    @action setBookingSearchSubCategory(value) {
        this.bookingSearchSubCategory = value;
    }

    @action setBookingTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {

        this.bookingTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.bookingTabCategories.find(fi => fi.id === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.bookingTabSubCategories = category.subCategories;
                return;
            }
        }

        this.bookingTabSubCategories = [];
    }

    @action setBookingPaymentOption(value) {
        this.bookingPaymentOption = value;
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    @action setBookingDate(value) {
        this.bookingDate = value;
        this.initGetBookings('');
    }

    @action setBookingDateText(value) {
        var selectedDate = moment(value).format('D/M/yyyy');
        this.bookingDateText = selectedDate;
    }

    @action setBookingDetailRemark(value) {
        if (this.bookingDetail) {
            this.bookingDetail.remark = value;
        }
    }

    @action setbookingDetailLoading(value) {
        this.bookingDetailLoading = value;
    }

    // RESET Properties

    @action resetBookings() {
        this.bookingItems = [];
        this.bookingFilterItems = this.bookingItems;
    }
}

export default new bookingSummaryStore()
